import styled from 'styled-components';

export const Manufacturers = styled.div`
  background: white;
  min-height: 100%;
`
